import { styled } from '@mui/material/styles';

export const CodeBlock = styled('pre')(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  border: `1px dashed ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  ...theme.typography.caption,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'anywhere',
}));
